import React, { useState } from 'react'
import { MdOutlineEditNote, MdOutlineThumbsUpDown } from 'react-icons/md'
import styled from 'styled-components'
import { SmallTomatoButton, TomatoButton } from '../../Layout/CommonStyle'
import { StudentRole, User } from '../../../models/User'
import { axiosPost } from '../../Common/Axios'
import { ApiResult } from '../../../models/Enums'
import toast from 'react-hot-toast'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { setStudentRole } from '../../../store/userSlice'

function Normal() {
  const [isRoleRegister, setIsRoleRegister] = useState(false)
  const [isRoleEvaluater, setIsRoleEvaluater] = useState(false)
  const [passwordRegister, setPasswordRegister] = useState('')
  const [passwordEvaluate, setPasswordEvaluate] = useState('')

  const me = useAppSelector((state: RootState) => state.user.me)
  const dispatch = useAppDispatch()

  const handleToggleRegister = () => {
    if (!isRoleRegister && isRoleEvaluater) {
      setIsRoleEvaluater(false)
    }
    setIsRoleRegister(!isRoleRegister)
  }

  const handleToggleEvaluate = () => {
    if (!isRoleEvaluater && isRoleRegister) {
      setIsRoleRegister(false)
    }
    setIsRoleEvaluater(!isRoleEvaluater)
  }

  const handleChangePasswordRegister = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPasswordRegister(e.target.value)
  }

  // 직업등록 비밀번호 확인
  const handleCommitPasswordRegister = async () => {
    const payload = {
      studentRole: StudentRole.REGISTER.toString(),
      userGroupId: me.groupId.toString(),
      password: passwordRegister,
    }
    const result = await axiosPost('/api/jobs/check_jobclass_password', payload)
    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('check_jobclass_password error', result.message)
      return
    }

    if (!result.data) {
      toast.error('비밀번호가 틀렸습니다.')
      return
    }

    // 빈등록을 해 놓는다. 다시 로그인하거나 다른 메뉴를 갔다와도 등록 상태를 유지하기 위해
    const resultJobs = {
      id: 0,
      userGroupId: me.groupId,
      writeUserId: me.id,
      jobName: '',
      jobContent: '',
      posterUrl: '',
    }
    const result2 = await axiosPost(
      '/api/jobs/save_result_jobs_only',
      resultJobs
    )
    if (result2.apiResult !== ApiResult.SUCCESS) {
      console.log('save_jobclass error', result2.message)
      return
    }

    console.log('setStudentRole', StudentRole.REGISTER)
    dispatch(setStudentRole(StudentRole.REGISTER))
  }

  const handleChangePasswordEvaluate = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPasswordEvaluate(e.target.value)
  }

  // 심사위원 비밀번호 확인
  const handleCommitPasswordEvaluate = async () => {
    const payload = {
      studentRole: StudentRole.EVALUATOR.toString(),
      userGroupId: me.groupId.toString(),
      password: passwordEvaluate,
    }
    const result = await axiosPost('/api/jobs/check_jobclass_password', payload)
    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('check_jobclass_password error', result.message)
      return
    }

    if (!result.data) {
      toast.error('비밀번호가 틀렸습니다.')
      return
    }

    console.log('setStudentRole', StudentRole.EVALUATOR)
    dispatch(setStudentRole(StudentRole.EVALUATOR))
  }

  return (
    <Container>
      <EnterButtons>
        <EnterButton>
          <button onClick={() => handleToggleRegister()}>
            <MdOutlineEditNote />
            직업등록
          </button>
        </EnterButton>
        <EnterButton>
          <button onClick={() => handleToggleEvaluate()}>
            <MdOutlineThumbsUpDown />
            심사위원
          </button>
        </EnterButton>
      </EnterButtons>
      <Passwords>
        {isRoleRegister && (
          <Password>
            <div>직업등록 비밀번호</div>
            <div>
              <input
                type="password"
                placeholder="비밀번호"
                onChange={handleChangePasswordRegister}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.keyCode === 13)
                    handleCommitPasswordRegister()
                }}
              />
              <SmallTomatoButton onClick={() => handleCommitPasswordRegister()}>
                확인
              </SmallTomatoButton>
            </div>
          </Password>
        )}
        {isRoleEvaluater && (
          <Password>
            <div>심사위원 비밀번호</div>
            <div>
              <input
                type="password"
                placeholder="비밀번호"
                onChange={handleChangePasswordEvaluate}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.keyCode === 13)
                    handleCommitPasswordEvaluate()
                }}
              />
              <SmallTomatoButton onClick={() => handleCommitPasswordEvaluate()}>
                확인
              </SmallTomatoButton>
            </div>
          </Password>
        )}
      </Passwords>
    </Container>
  )
}

const Container = styled.div`
  text-align: center;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 20px;
`

const EnterButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 20px;
`

const EnterButton = styled.div`
  button {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 10px;
    padding: 25px 15px;
    font-size: 1.1rem;
  }
`

const Passwords = styled.div`
  min-height: 200px;
`

const Password = styled.div`
  div:nth-child(1) {
  }
  div:nth-child(2) {
    input {
      padding: 5px 3px;
      margin-right: 5px;
      width: 100px;
    }
    button {
      padding: 5px 3px;
      max-width: 100px;
    }
  }
`

export default Normal
